import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Header,
  Icon,
  Button,
  Loader,
  Segment,
  Select,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import { ListSubjectGrade } from "../../../components/Admin/Media";
import { useAuth } from "../../../hooks";
import { Syllabu, Grade, Level } from "../../../api";
import "./Media.scss";

const syllabuController = new Syllabu();
const gradeController = new Grade();
const levelController = new Level();

export function Media() {
  const [reload, setReload] = useState(false);
  const [syllabu, setSyllabu] = useState(null);
  const { accessToken } = useAuth();
  const { syllabuId } = useParams();
  const [levels, setLevels] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [grades, setGrades] = useState([]);
  const [selectedGrade, setSelectedGrade] = useState(null);

  const onReload = () => setReload((prevState) => !prevState);

  useEffect(() => {
    (async () => {
      try {
        const response = await syllabuController.getSyllabu(
          accessToken,
          syllabuId,
        );
        setSyllabu(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [syllabuId, accessToken]);

  useEffect(() => {
    (async () => {
      try {
        const response = await levelController.getLevels(accessToken);
        setLevels(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [accessToken]);

  useEffect(() => {
    if (!selectedLevel) return;
    (async () => {
      try {
        setGrades([]);
        setSelectedGrade(null);
        const response = await gradeController.getGradesByLevelId(
          selectedLevel,
          accessToken,
        );
        setGrades(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [selectedLevel, accessToken]);

  const levelOptions = [
    { key: "", value: "", text: "Selecciona un nivel" },
    ...levels.map((level) => ({
      key: level.id,
      text: level.name,
      value: level.id,
    })),
  ];

  const gradeOptions = [
    { key: "", value: "", text: "Selecciona un grado" },
    ...grades.map((grade) => ({
      key: grade.id,
      text: grade.name,
      value: grade.id,
    })),
  ];

  const currentGrade = grades.find((g) => g.id === selectedGrade) || null;

  if (!syllabu) return <Loader active inline="centered" />;

  return (
    <>
      <div className="media-page">
        <div className="media-page__header">
          <Header as="h3">
            <Icon name="book" />
            <Header.Content>
              Contenido multimedia de {syllabu.name}
            </Header.Content>
          </Header>
          <Button
            className="media-page__add"
            color="grey"
            as={Link}
            to="/admin/syllabu"
          >
            Volver
          </Button>
        </div>
        <div className="media-page__selects">
          <Select
            className="edunova-select"
            clearable
            placeholder="Selecciona un nivel"
            options={levelOptions}
            value={selectedLevel}
            onChange={(_, { value }) => setSelectedLevel(value)}
          />
          <Select
            className="edunova-select"
            clearable
            placeholder="Seleccionar grado"
            options={gradeOptions}
            value={selectedGrade}
            onChange={(_, { value }) => setSelectedGrade(value)}
            disabled={grades.length === 0}
          />
        </div>
        {!selectedLevel || !selectedGrade ? (
          <Segment placeholder textAlign="center">
            <Header icon>
              <Icon name="hand point up outline" />
              Selecciona un nivel y un grado para ver el contenido multimedia.
            </Header>
          </Segment>
        ) : (
          <Segment>
            <ListSubjectGrade
              syllabuId={syllabuId}
              grade={currentGrade}
              reload={reload}
              onReload={onReload}
            />
          </Segment>
        )}
      </div>
    </>
  );
}
